
import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BntGenericBoard from '../PopUps/BntGenericBoard';
import GenericBoard from '../Button/ButtonCard/GenericBoard';
import './Card.css';
import { Box, Typography } from '@mui/material';

/**
 * GenericHPC component renders a card with generic board information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleGeneric - The callback function to handle generic HPC board.
 * @param {Function} props.handleGenericDecrement - The callback function to handle decrement of generic HPC board.
 * @param {Boolean} props.reset - Whether to reset the generic HPC board.
 */
const GenericHPC = ({
    /**
     * The callback function to handle generic HPC board.
     */
    handleGeneric,module ,handleDecrement,
    /**
     * The callback function to handle decrement of generic HPC board.
     */
    handleGenericDecrement,
    /**
     * Whether to reset the generic HPC board.
     */
    reset
  }) => {
    const [open, setOpen] = useState(false);
  
    /**
     * Handles the click event to open the generic HPC board popup.
     */
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    return (
      <Card variant="outlined"
        /**
         * Custom styles for the card container
         */
       sx={{
        width: '430px',
        height: '180px',
        border: 'none',
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
      }}>
        <CardContent>

            <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: 2
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontFamily: 'Open Sans',
                        m: 0,
                        
                        fontWeight: 'bold',
                      }}
                    >
            Generic HPC
                    </Typography>
          
                   <BntGenericBoard size="small" onClick={handleClickOpen}>
           
            </BntGenericBoard>
                  </Box>
          
      
  
          <GenericBoard
          text='Generic HPC'
            onClick={()=>handleGeneric(module)}
            handleGenericDecrement={()=>handleDecrement(module)}
            reset={reset}
          />
  
          <p   style={{
            fontFamily: 'Open Sans',
            fontSize: '12px',
            marginRight: '16%'
          }}>
An ADHA-compliant 3U generic expansion board 
built around the PolarFire FPGA.          </p>
  
   
        </CardContent>
      </Card>
    );
  };
  
  /**
   * Exports the GenericHPC component as the default export.
   */
  export default GenericHPC;